import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { sharedModule } from "src/app/shared/shared.module";
import { StudentCourseComponent } from './student-course/student-course.component';
import { RegisterCoursesComponent } from './student-course/register-courses/register-courses.component';
import { CourseDetailsComponent } from './student-course/course-details/course-details.component';
import { StudenteducationalbackgroundComponent } from './student-course/studenteducationalbackground/studenteducationalbackground.component';
import { StudentPlacementComponent } from './student-placement/student-placement.component';
import { PlacementReservationsComponent } from "./student-placement/placement-reservations/placement-reservations.component";
import { PlacementReservationEntryComponent } from "./student-placement/placement-reservation-entry/placement-reservation-entry.component";
import { PlacementPaymentComponent } from "./student-placement/placement-payment/placement-payment.component";
import { PlacementDetailComponent } from "./student-placement/placement-detail/placement-detail.component";
import { StudentDiscountComponent } from "./student-discount/student-discount.component";
import { StudentDocumentsComponent } from "./student-discount/student-documents/student-documents.component";
import { SendDocumentComponent } from "./student-discount/send-document/send-document.component";
import { StudentInvoiceComponent } from './student-invoice/student-invoice.component';
import { InvoicesComponent } from './student-invoice/invoices/invoices.component';
import { RegistrationCourseComponent } from './student-course/registration-course/registration-course.component';
import { ConfirmRegistrationEntryComponent } from "./student-course/confirm-registration-entry/confirm-registration-entry.component";
import { RefoundEntryComponent } from "./student-invoice/refound-entry/refound-entry.component";
import { AngularTiltModule } from "angular-tilt";
import { ExtensionFilePipe } from "./student-discount/student-documents/extension-file.pipe";
import { SubmitSurveyComponent } from './student-course/submit-survey/submit-survey.component';

import { StudentPrivateClassComponent } from './student-private-class/student-private-class.component';
import { RequestPrivateClassListComponent } from './student-private-class/request-private-class-list/request-private-class-list.component';
import { RequestPrivateClassComponent } from "./student-private-class/request-private-class/request-private-class.component";
import { RegistrationHistoryReportComponent } from './student-course/registration-history-report/registration-history-report.component';
import { StudentProfileEditComponent } from './student-profile-edit/student-profile-edit.component';
import { SessionListComponent } from './student-course/session-list/session-list.component';

@NgModule({

  declarations: [
    // Course
    StudentCourseComponent,
    RegisterCoursesComponent,
    CourseDetailsComponent,
    StudenteducationalbackgroundComponent,
    RegistrationCourseComponent,
    ConfirmRegistrationEntryComponent,
    // Placement
    StudentPlacementComponent,
    PlacementReservationsComponent,
    PlacementReservationEntryComponent,
    PlacementPaymentComponent,
    PlacementDetailComponent,
    // Discount
    StudentDiscountComponent,
    StudentDocumentsComponent,
    SendDocumentComponent,
    // Invoice
    StudentInvoiceComponent,
    InvoicesComponent,
    RefoundEntryComponent,
    // pipe
    ExtensionFilePipe,
    SubmitSurveyComponent,
    //private class
    StudentPrivateClassComponent,
    RequestPrivateClassListComponent,
    RequestPrivateClassComponent,
    RegistrationHistoryReportComponent,
    StudentProfileEditComponent,
    SessionListComponent
  ],
  imports: [sharedModule, FormsModule, AngularTiltModule],
  entryComponents: [
    // Course
    CourseDetailsComponent,
    ConfirmRegistrationEntryComponent,
    SubmitSurveyComponent,
    // Placement
    PlacementReservationEntryComponent,
    PlacementPaymentComponent,
    PlacementDetailComponent,
    // Discount
    SendDocumentComponent,
    // Invoice
    RefoundEntryComponent,
    RequestPrivateClassComponent,
    RegistrationHistoryReportComponent,
    SessionListComponent
  ]
})
export class studentModule { }
